import { render } from "./mp_swiper.vue?vue&type=template&id=32111869&scoped=true"
import script from "./mp_swiper.vue?vue&type=script&lang=js"
export * from "./mp_swiper.vue?vue&type=script&lang=js"

import "./mp_swiper.vue?vue&type=style&index=0&id=32111869&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32111869"]])

export default __exports__